import React from 'react';

import ReaderContextProvider from '../components/Reader/ReaderContext';
import AIAssistantProvider from '../state/AIAssistantContextProvider';
import { CollectionFormModalProvider } from '../state/CollectionFormModalProvider';
import CookiebotContextProvider from '../state/CookiebotContextProvider';
import { ManageItemInCollectionModalProvider } from '../state/ManageItemInCollectionModalProvider';
import { ManageItemInCollectionProvider } from '../state/ManageItemInCollectionProvider';
import { MasterLayoutProvider } from '../state/MasterLayoutProvider';
import { NotificationProvider } from '../state/NotificationContextProvider';
import { SearchFiltersDialogProvider } from '../state/SearchFiltersDialogProvider';
import { SnackbarContextProvider } from '../state/SnackbarContextProvider';
import { RouterProvider } from '../utils/useRouter';

const contexts: (React.FC | React.ComponentType)[] = [
	NotificationProvider,
	RouterProvider,
	CookiebotContextProvider,
	CollectionFormModalProvider,
	ManageItemInCollectionProvider,
	ManageItemInCollectionModalProvider,
	SnackbarContextProvider,
	SearchFiltersDialogProvider,
	MasterLayoutProvider,
	ReaderContextProvider,
	AIAssistantProvider,
];

const Contexts: React.FC = (props) => (
	<>
		{contexts.reduceRight(
			(previous, Current) => (
				// biome-ignore lint/correctness/useJsxKeyInIterable: reduceRight composes nested providers into one element, not a sibling list
				<Current>{previous}</Current>
			),
			props.children
		)}
	</>
);

export default Contexts;
